"use client";
import Image from "next/image";
import Link from "next/link";
import { useRef } from "react";
const links = [
  ["/verin-hydraulique-sur-mesure", "Sur mesure"],
  ["/reconditionnement-verin-hydraulique-sur-mesure", "Remise à neuf"],
  ["/conception-verin-hydraulique", "Bureau d’études"],
  ["/secteurs", "Secteurs"],
  ["/realisations", "Réalisations"],
  ["/services", "Accumulateurs et multiplicateurs"],
  ["/blog", "Blog"],
];
export default function Header() {
  const menu = useRef<HTMLDetailsElement>(null);
  return (
    <>
      <header data-review-id="V00" className="cro-header">
        <Link href="/" className="cro-brand">
          <Image
            src="/images/logo-secmhy.png"
            alt="SECMHY Vérins"
            width={180}
            height={66}
            priority
          />
        </Link>
        <nav className="cro-desktop" aria-label="Navigation principale">
          {links.map(([href, label]) => (
            <Link key={href} href={href}>
              {label}
            </Link>
          ))}
        </nav>
        <a className="cro-header-phone" href="tel:+33477936882">
          04 77 93 68 82
        </a>
        <Link className="cro-button" href="/demande">
          Présenter votre projet
        </Link>
        <details
          ref={menu}
          className="cro-mobile-menu"
          onKeyDown={(e) => {
            if (e.key === "Escape" && menu.current) {
              menu.current.open = false;
              menu.current.querySelector("summary")?.focus();
            }
          }}
        >
          <summary>Menu</summary>
          <nav aria-label="Navigation mobile">
            {links.map(([href, label]) => (
              <Link
                key={href}
                href={href}
                onClick={() => {
                  if (menu.current) menu.current.open = false;
                }}
              >
                {label}
              </Link>
            ))}
          </nav>
        </details>
      </header>
      <div className="cro-mobile-bar">
        <a href="tel:+33477936882">Appeler</a>
        <Link href="/demande">Demande</Link>
      </div>
    </>
  );
}
